'use client';

import { TrendingUp, BarChart3, Radio, Zap } from 'lucide-react';
import { useOverviewStats } from '@/hooks/use-trends';

function StatSkeleton() {
  return (
    <div className="bg-card rounded-lg p-4 animate-pulse">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-muted" />
        <div className="space-y-2">
          <div className="h-6 w-16 rounded bg-muted" />
          <div className="h-3 w-24 rounded bg-muted" />
        </div>
      </div>
    </div>
  );
}

export function OverviewStats() {
  const { data, isLoading } = useOverviewStats();

  if (isLoading || !data) {
    return (
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatSkeleton />
        <StatSkeleton />
        <StatSkeleton />
        <StatSkeleton />
      </div>
    );
  }

  const stats = [
    {
      icon: TrendingUp,
      value: data.total_trends.toLocaleString(),
      label: 'Всего трендов',
      color: 'text-blue-400',
    },
    {
      icon: BarChart3,
      value: data.average_score.toFixed(1),
      label: 'Средний балл',
      color: 'text-green-400',
    },
    {
      icon: Radio,
      value: `${data.active_sources.active}/${data.active_sources.total}`,
      label: 'Источники',
      color: 'text-amber-400',
    },
    {
      icon: Zap,
      value: data.accelerating_count.toLocaleString(),
      label: 'Ускоряющихся',
      color: 'text-indigo-400',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-card rounded-lg p-4">
          <div className="flex items-center gap-3">
            <div className={`flex h-10 w-10 items-center justify-center rounded-lg bg-muted ${stat.color}`}>
              <stat.icon className="h-5 w-5" />
            </div>
            <div>
              <p className="text-2xl font-bold text-card-foreground">{stat.value}</p>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
